const plZipCodeRegEx = /^(\d\d?)(?! )(-?)(\d?\d?\d?)/;

const plZipCodeMask = (input = ''): string => {
  const match = plZipCodeRegEx.exec(input.replace(/\D/g, ''));
  if (!match) {
    return '';
  }

  let result = [match[1]];

  if (match[3]?.length) {
    result = [match[1], '-', match[3]];
  }

  return result.filter(group => group?.length).join('');
};

export default plZipCodeMask;
